import axios from 'axios';
import app from './app';

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name~=_token]').getAttribute('content');
window.axios = axios;

/** @deprecated Use beforeRouteEnter instead of serverPrefetch for data fetching */
if (window.__INITIAL_STATE__) {
  app.$store.replaceState(window.__INITIAL_STATE__);
}

app.$mount('#site-app');
